<template>
    <div>
      <h1>404</h1>
    </div>
</template>

<script>
    export default {
        name: "Page404",
        created: function () {
          document.querySelector('#app').style.display = 'block'
          $('body').addClass('body_404')

        }
    }
</script>

<style >
 .body_404 .bg {
   display: none;
 }
 .body_404 h1 {
  font-size: 80px;
  display: block;
  margin: auto;
  text-align: center;
  margin-top: 100px;
}

</style>



// WEBPACK FOOTER //
// src/components/Page404.vue